import * as React from "react";

import { useLocation } from "react-router-dom";

import { useFeatureFlags } from "client/hooks/useFeatureFlags";
import { useWindowLocation } from "client/hooks/useWindowLocation";
import {
  Branding,
  getBrandingFromDecisionEngine,
  getBrandMap,
  L10n,
} from "client/utils/branding";

export const L10nContext = React.createContext<L10n | undefined>(undefined);

L10nContext.displayName = "L10nContext";

export const getBranding = (useNewDecisionEngine = false): Branding => {
  if (useNewDecisionEngine) {
    return getBrandingFromDecisionEngine();
  }

  if (location?.href.toLowerCase().includes("clearpay")) {
    return "Clearpay";
  }
  return "Afterpay";
};

export const BrandingProvider: React.FC = ({ children }) => {
  const [branding, setBranding] = React.useState<Branding>(getBranding());
  const windowLocation = useWindowLocation();
  const location = useLocation();
  const brandAssets = getBrandMap()[branding];
  const { brandTitle, favicon } = brandAssets;
  const [{ merchantPortalCashAppAfterpayTheme }] = useFeatureFlags();

  React.useEffect(() => {
    setBranding(getBranding(merchantPortalCashAppAfterpayTheme));
  }, [windowLocation, merchantPortalCashAppAfterpayTheme, location]);

  React.useEffect(() => {
    document.title = brandTitle;

    const link = document.querySelector("link[rel='shortcut icon']");
    if (link) link.setAttribute("href", favicon);
  }, [brandTitle, favicon]);

  return (
    <L10nContext.Provider value={brandAssets}>{children}</L10nContext.Provider>
  );
};
